export const enum TripReasonTransportEnum {
  FccNonMedical = 683,
  NonMedicalMMA = 607,
  NonMedicalMCR = 712,
  NonMedicalCha = 347,
  Pharmacy = 690
}



// WEBPACK FOOTER //
// ./src/app/core/enums/trip-reason-transport.enum.ts